import { PlaceHolder } from "@/services/smsPlaceHolders/type";
import { OPT_OUT, smsSegments } from "@/modules/smsLibrary/sms";
import classes from "./campaign.module.css";

type Piece = { text: string; kind?: "value" | "link" | "missing" };
const escape = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// The template as one customer reads it: each placeholder becomes its sample value, or its name when the
// salon has not filled it in.
export function fillTemplate(text: string, tags: PlaceHolder[]): { pieces: Piece[]; filled: string } {
  const byKey = new Map(tags.filter((tag) => tag.key).map((tag) => [tag.key!, tag]));
  if (!byKey.size) return { pieces: [{ text }], filled: text };
  const pattern = new RegExp(`(${[...byKey.keys()].map(escape).join("|")})`, "g");
  const pieces = text
    .split(pattern)
    .filter(Boolean)
    .map((piece): Piece => {
      const tag = byKey.get(piece);
      if (!tag) return { text: piece };
      if (!tag.preView) return { text: tag.value || piece, kind: "missing" };
      return { text: tag.preView, kind: /link|location/i.test(tag.key ?? "") ? "link" : "value" };
    });
  return { pieces, filled: pieces.map((piece) => piece.text).join("") };
}

// SMS parts per recipient, counting the opt-out line the backend appends.
export const smsPartsOf = (text: string, tags: PlaceHolder[]) =>
  smsSegments(fillTemplate(text, tags).filled.length + OPT_OUT.length + 1).segments;

const pieceClass = { value: classes.fillValue, link: classes.fillLink, missing: classes.fillMissing };

export default function MessageText({ text, tags }: { text: string; tags: PlaceHolder[] }) {
  const { pieces } = fillTemplate(text, tags);
  return (
    <>
      {pieces.map((piece, index) =>
        piece.kind ? (
          <span key={index} className={pieceClass[piece.kind]} dir={piece.kind === "link" ? "ltr" : undefined} title={piece.kind === "missing" ? "این مقدار را هنوز وارد نکرده‌اید" : undefined}>
            {piece.text}
          </span>
        ) : (
          piece.text
        ),
      )}
    </>
  );
}
